import { useEffect } from "react";

export default function useRevealOnScroll() {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    if (!elements.length) return;

    const reveal = () => {
      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          el.classList.add("active");
        }
      });
    };

    reveal();

    window.addEventListener("scroll", reveal, { passive: true });

    return () => {
      window.removeEventListener("scroll", reveal);
    };
  }, []);
}
